import Vue from 'vue';
import Router from 'vue-router';
import Main from '@/views/Main';
import MainChildrenRoutes from './main';

Vue.use(Router);
// 重复指向路由报错
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: MainChildrenRoutes,
      meta: {
        title: "首页"
      }
    }
  ],
});

export default router;

/*
router.afterEach((to, from) => {
  if (to.name !== from.name && to.query.per_page && to.query.per_page != 10) {
    to.query.per_page = 10;

    router.replace({
      query: to.query
    })
  }
})
*/



// WEBPACK FOOTER //
// ./src/router/index.js